import styled from 'styled-components';
import Title from 'js/components/core/Title';

export default styled(Title)`
  line-height: 1.5rem;
  color: black;
`;
